<template>
  <z-table
    :fields="changes_fields"
    :items="changes"
    :show_header="false"
    :show_pagination_description="false"
  >
    <template slot="state" slot-scope="{ item: row }">
      <span
        :class="{
          'text-success': row.state === 'add',
          'text-danger': row.state === 'remove'
        }"
      >
        {{ $t(`pbx.phone-list.form.state.${row.state}`) }}
      </span>
    </template>

    <template slot="actions" slot-scope="{ item: row }">
      <table-control type="trash" @click="removeChange(row.id)" />
    </template>
  </z-table>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('pbx/phone-lists/form/table', ['changes']),

      changes_fields: function () {
        return [
          {
            key: 'phone',
            label: this.$t('pbx.phone-list.form.field.phone'),
            sortable: false
          },
          {
            key: 'state',
            label: this.$t('pbx.phone-list.form.field.state'),
            sortable: false,
            class: 'text-center'
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center'
          }
        ];
      }
    },

    created() {
      /* reseting ui-table by numbers */
      this.resetChanges();
    },

    methods: {
      ...mapActions('pbx/phone-lists/form/table', ['removeChange', 'resetChanges'])
    }
  };
</script>
